const enApp = {
    // Analysis page
    matchAnalysisTitle: "Match analysis",
    enterTeamsSubtitle: "Enter the teams you want to analyse",
    aiNotice: "Our AI is connected to football news and crosses millions of data points for each prediction",
    matchToAnalyze: "Match to analyse",
    teamSearchPlaceholder: "Search a team (PSG, Barcelona, Inter, etc)",
    teamSearchUnavailable: "Team search is unavailable at the moment, please try again shortly",
    teamSearchNoResult: "No team found with this name",
    versus: "VS",
    analyzeWithAi: "Analyse the match with AI",
    clearSearch: "Clear",
    backToTeamSearch: "Back to team search",
    analysesLeftToday: "{{count}} analysis left today",

    upcomingMatches: "Upcoming matches",
    upcomingMatchesOf: "Upcoming matches of {{team}}",
    upcomingMatchesBetween: "Upcoming matches between {{home}} and {{away}}",
    searchingUpcoming: "searching for upcoming matches",
    pickTeamHint: "Pick a team to see the matches it has coming up",
    notCoveredYet: "{{teams}} is not covered by the prediction database yet",
    noUpcomingMatch: "No upcoming match found",

    // Browsing by competition
    searchByTeams: "By teams",
    searchByCompetition: "By competition",
    competitionSearchPlaceholder: "Search a competition (Premier League, Ligue 1, etc)",
    competitionSearchNoResult: "No competition found with this name",
    competitionSearchUnavailable: "Competitions are unavailable at the moment, please try again shortly",
    pickCompetitionHint: "Pick a competition to see the matches it has coming up",
    upcomingMatchesIn: "Upcoming matches in {{competition}}",
    noUpcomingMatchInCompetition: "No upcoming match in this competition",

    // Analysis progress
    matchingTeams: "Matching {{home}} and {{away}}",
    retrievingPredictions: "Retrieving the AI predictions",
    analysisReady: "Analysis ready",
    crossingData: "Crossing the data of both teams, this takes a few seconds",
    cancelAnalysis: "Cancel",
    pickBothTeams: "Pick both teams before starting the analysis",
    noExactMatch: "No exact match for {{teams}} in the prediction database",
    noUpcomingBetween: "No upcoming match found between {{home}} and {{away}}",
    analysisFailed: "The analysis could not be completed, please try again",

    // What the API answers when a plan does not cover the analysis
    denialNoSubscriptionTitle: "A plan is needed",
    denialNoSubscriptionDescription: "AI predictions are for subscribers. Pick a plan to run your first analysis.",
    denialExpiredTitle: "Your access has expired",
    denialExpiredDescription: "Your plan has run its course. Renew it to get your predictions back.",
    denialLimitTitle: "Daily limit reached",
    denialLimitDescription: "You have used every analysis of the day. They come back at midnight, or move up a plan.",
    denialResetAt: "Next analyses at {{time}}",
    seePlans: "See the plans",

    // Prediction panel
    panelHome: "HOME",
    panelAway: "AWAY",
    panelDraw: "DRAW",
    panelWin: "WIN",
    panelConfidenceHigh: "HIGH CONFIDENCE",
    panelConfidenceMedium: "MED CONFIDENCE",
    panelConfidenceLow: "LOW CONFIDENCE",
    panelBtts: "BTTS",
    panelFirstHalf: "1ST HALF",
    panelFirstScorer: "1ST SCORER",
    panelGoals: "GOALS",
    panelExactScore: "EXACT SCORE",
    panelRecommendedBets: "RECOMMENDED BETS",
    panelAiReasoning: "AI REASONING",
    panelYes: "Yes",
    panelNo: "No",
    panelNeither: "Neither",
    panelTotal: "TOTAL",
    panelStatusScheduled: "SCHEDULED",
    panelStatusLive: "LIVE",
    panelStatusFinished: "FULL TIME",
    panelStatusCanceled: "CANCELED",
    panelStatusTbd: "TBD",
    betMatchWinner: "Match winner",
    betTotalGoals: "Total goals",
    betHomeGoals: "Home goals",
    betAwayGoals: "Away goals",
    betBothTeamsScore: "Both teams score",
    betFirstHalfWinner: "1st half winner",
    betFirstToScore: "First to score",
    betExactScore: "Exact score",
    betGoalsSuffix: "Goals",
    panelNoPrediction: "No prediction available for this match",

    // History
    historyTitle: "History",
    historySubtitle: "Every match you have analysed",
    historyNotice: "Your analyses are kept on this device, reopening one does not use up an analysis",
    noAnalysisYet: "No analysis yet",
    noAnalysisYetDescription: "The matches you analyse show up here, with their full prediction panel.",
    analyzeAMatch: "Analyse a match",
    savedAnalyses: "{{count}} saved analysis",
    filterPlaceholder: "Filter by team or competition",
    noAnalysisMatches: "No analysis matches \"{{query}}\"",
    analyzedOn: "Analysed on {{date}}",
    showAnalysis: "Show the analysis",
    hideAnalysis: "Hide the analysis",
    removeFromHistory: "Remove from the history",

    // Account
    profile: "Profile",
    displayName: "Display name",
    yourNamePlaceholder: "Your name",
    emailLabel: "Email",
    emailNotice: "Your email identifies your account and cannot be changed here. Contact support if it needs to move.",
    memberSince: "Member since {{date}}",
    emailAndPassword: "Email & password",
    googleLabel: "Google",
    planSuffix: "{{plan}} plan",
    yourPlan: "Your plan",
    analysesUsedToday: "Analyses used today",
    dailyLimitReached: "Daily limit reached, it resets tomorrow",
    leftUntilTomorrow: "{{count}} left until tomorrow",
    renewsOn: "Ends on",
    endedOn: "Ended on",
    seeAllPlans: "See all plans",
    upgradeMyPlan: "Choose a plan",
    security: "Security",
    changePasswordNotice: "Change your password. Your current one is asked for to confirm it is really you.",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    changePassword: "Change password",
    googleAccountNotice: "You sign in with Google, so your password is managed by your Google account.",
    setPasswordNotice: "You sign in with Google. Set a password to also sign in with your email and this password.",
    setPassword: "Set password",
    passwordSet: "Your password has been set, you can now sign in with your email",
    nameEmpty: "Your name cannot be empty",
    nameUpdated: "Your name has been updated",
    passwordChanged: "Your password has been changed",
    passwordTooShort: "Your new password needs at least {{min}} characters",
    statusActive: "active",
    statusExpired: "expired",
    statusCancelled: "cancelled",
    statusPaused: "paused",

    // Referrals
    inviteFriends: "Invite friends",
    referralPitch: "They get {{referred}}% off their first plan, you get {{referrer}}% off your next payment for every friend who joins.",
    yourCode: "Your code",
    referralCodeCopied: "Referral code copied",
    invitationLinkCopied: "Invitation link copied",
    copyUnavailable: "Copy is unavailable, please select the text manually",
    friendsJoined: "Friends joined",
    creditsAvailable: "Credits available",
    offNextPayment: "Off next payment",
    yourDiscounts: "Your discounts",
    usedOn: "Used on {{date}}",
    validUntil: "Valid until {{date}}",
    noOneUsedCode: "No one has used your code yet. Share the link above to start earning discounts.",
    creditOriginReferrer: "Friend invited",
    creditOriginReferred: "Welcome bonus",
    creditStatusAvailable: "available",
    creditStatusConsumed: "used",
    creditStatusExpired: "expired",
    percentOff: "{{percent}}% off"
}

export default enApp
